<script setup lang="ts">
const config = useRuntimeConfig()
const route = useRoute()

const defaultOgImage = `${config.public.appUrl}/og-default.png`
const defaultTitle = `${config.public.appName} - Ofertas, Promocoes e Cupons`
const defaultDescription = 'Ofertas, promocoes e cupons das maiores lojas do Brasil em um so lugar. Descubra descontos em alta e compartilhe oportunidades com contexto.'
const pageUrl = computed(() => `${config.public.appUrl}${route.path}`)

useHead({
  htmlAttrs: {
    lang: 'pt-BR',
  },
  titleTemplate: (titleChunk?: string) =>
    titleChunk && titleChunk !== config.public.appName
      ? `${titleChunk}`
      : defaultTitle,
  link: [
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'shortcut icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'mask-icon', href: '/favicon.svg', color: '#00E676' },
    { rel: 'manifest', href: '/site.webmanifest' },
    { rel: 'canonical', href: pageUrl },
  ],
  meta: [
    { name: 'application-name', content: config.public.appName },
    { name: 'apple-mobile-web-app-title', content: config.public.appName },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'theme-color', content: '#00e676' },
    { name: 'msapplication-TileColor', content: '#020817' },
  ],
})

useSeoMeta({
  title: defaultTitle,
  description: defaultDescription,
  robots: 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
  ogTitle: defaultTitle,
  ogDescription: defaultDescription,
  ogSiteName: config.public.appName,
  ogLocale: 'pt_BR',
  ogType: 'website',
  ogUrl: pageUrl,
  ogImage: defaultOgImage,
  ogImageAlt: 'Descontito com ofertas, promocoes e cupons em destaque',
  twitterTitle: defaultTitle,
  twitterDescription: defaultDescription,
  twitterCard: 'summary_large_image',
  twitterImage: defaultOgImage,
  twitterImageAlt: 'Descontito com ofertas, promocoes e cupons em destaque',
})

useHead({
  meta: [
    { property: 'og:image:url', content: defaultOgImage },
    { property: 'og:image:secure_url', content: defaultOgImage },
    { property: 'og:image:type', content: 'image/png' },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { name: 'twitter:image:width', content: '1200' },
    { name: 'twitter:image:height', content: '630' },
  ],
})

useSchemaOrg([
  defineWebSite({
    name: config.public.appName,
    url: config.public.appUrl,
    inLanguage: 'pt-BR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${config.public.appUrl}/busca?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  }),
  defineOrganization({
    name: config.public.appName,
    url: config.public.appUrl,
    logo: `${config.public.appUrl}/favicon.svg`,
  }),
])
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
